import _ from 'lodash';
import {
  AD_TYPE,
  NORMAL_AD_SOURCES,
  imgSrcPrefix,
  imageMode,
  DISCLAIMER_TYPES,
  CAROUSEL_ENABLE_OBJECTIVE_LIST_V1,
  CAROUSEL_ENABLE_OBJECTIVE_LIST_V2,
  CREATIVE_TYPE,
  CARD_ADDITIONAL_CREATIVE_TYPE,
  ADDITIONAL_CREATIVE_ATTACHMENT_EXPERIENCE_TYPES,
  GET_SPECIAL_ADDITIONAL_CREATIVE_INSTANT_PAGE_TEMPLATE_TYPES,
  identityAvailableStatus,
  PixeOnlyTracking,
  bcIdentityTypesList,
  NATIVE_AD_ACTION_TYPE,
} from 'src/const/state/creative';
import { ADDITIONAL_CREATIVE_PARAMS } from 'src/store/modules/creative/normal-creative/state';
// import { ADVANCED_CREATIVE_TYPE } from 'src/const/state/call-to-action';
import { INVENTORY_FLOW_MAP, INVENTORY_FLOW } from 'src/const/state/inventory-type';
import {
  isVigoWhite,
  isSupportPangleImage,
  isCarouselImageCreativeAllowed_v1,
  isCarouselImageCreativeAllowed_v2,
  isCreativeHasIdentityWhite,
} from 'src/const/whiteList';
import { randomString } from 'src/utils/strUtil';
import getAutoGenerateCreativeName from 'src/utils/getAutoGenerateCreativeName';
import { customizedAdditionalCreativeObjectiveTypes } from 'src/const/creative/additionalAdsEnable';
import { PRODUCT_SELECTION_TYPE, shopStateMap } from 'src/const/state/shop';
import { transformTitle4Backend, isAdEmpty, isValidAdSource } from './helpers';

const {
  SINGLE_IMAGE, SINGLE_VIDEO, CATALOGUE_VIDEO, CATALOGUE_IMAGE, CAROUSEL_IMAGE, REAL_TIME_LIVE,
} = AD_TYPE;
const { CREATE_NEW, NATIVE_VIDEO } = NORMAL_AD_SOURCES;
const { IMAGE_CARD: ADDITION_IMAGE_CARD_NAME, INSTANT_PAGE: INSTANT_PAGE_NAME } = ADDITIONAL_CREATIVE_ATTACHMENT_EXPERIENCE_TYPES;
const getIsInstantPageChecked = ({ cardAdditionalInfo = {} }) => cardAdditionalInfo?.[INSTANT_PAGE_NAME]?.isChecked;

const getIsAppProfileInstantPageChecked = ({ cardAdditionalInfo = {} }) => cardAdditionalInfo?.[INSTANT_PAGE_NAME]?.isChecked
  && cardAdditionalInfo?.[INSTANT_PAGE_NAME]?.template_name
    === GET_SPECIAL_ADDITIONAL_CREATIVE_INSTANT_PAGE_TEMPLATE_TYPES()?.APP_PROFILE_INSTANT_PAGE?.value;

const getIsAdditionalCardChecked = ({ cardAdditionalInfo = {} }) => cardAdditionalInfo?.[ADDITION_IMAGE_CARD_NAME]?.isChecked;

const autoNameCreativeCountAdUnit = (adsUnit) => {
  try {
    return adsUnit.filter((ad) => {
      const { adSource } = ad;
      const sourceTarget = ad[adSource];
      const { adType } = sourceTarget;
      const item = _.cloneDeep(sourceTarget[adType]);
      return item.isUseAutoGenerateCreativeName;
    }, []).length;
  } catch (e) {
    return 0;
  }
};
const videoRenderCreativeCountAdUnit = (adsUnit) => {
  try {
    return adsUnit.filter((ad) => {
      const { adSource } = ad;
      const sourceTarget = ad[adSource];
      const { adType } = sourceTarget;
      const item = _.cloneDeep(sourceTarget[adType]);
      return item.taskId;
    }, []).length;
  } catch (e) {
    return 0;
  }
};
export default {
  isDpa(state, getters, rootState, rootGetters) {
    return rootGetters['campaign/adgroup/isDpa'];
  },
  isShop(state, getters, rootState, rootGetters) {
    return rootGetters['campaign/adgroup/isShop'];
  },
  isShopLive(state, getters, rootState, rootGetters) {
    return rootGetters['campaign/adgroup/isShopLive'];
  },
  adStorageKey(state, getters, rootState, rootGetter) {
    return `${ rootGetter['campaign/modelKey'] }:ad`;
  },
  // 把vuex的数据处理成接口需要的数据结构
  // 1. 移出一些不必要的字段
  adsUnitCreativeInfo(state, getters, rootState, rootGetters) {
    return (adsUnit, creativeRevertFieldArr) => {
      const result = {};

      const isRF = rootGetters['campaign/adgroup/isRF'];
      adsUnit.forEach((ad) => {
        const { adSource } = ad;
        if (!isValidAdSource(adSource)) {
          return;
        }
        const sourceTarget = ad[adSource];
        const { adType } = sourceTarget;
        let item = _.cloneDeep(sourceTarget[adType]);
        let creativeRevertValueMap = {};
        if (Array.isArray(creativeRevertFieldArr)) { // 需要保留的字段的数组
          creativeRevertValueMap = creativeRevertFieldArr.reduce((pre, field) => {
            pre[field] = item[field];
            return pre;
          }, {});
        }
        if (!item) {
          return;
        }
        // 跳过校验失败的创意
        if (isRF && (!item.is_valid && item.is_valid !== undefined)) {
          return;
        }
        // 清除 creative_type 前判断状态
        const isCollectionAds = item.creative_type === CREATIVE_TYPE.LYNX_PLP;
        // 是否自定义附加创意
        const objectiveType = _.get(rootState, 'campaign.adgroup.objective_type');
        // 选择only pixel清空domain
        if (item.domain === PixeOnlyTracking || !!item.page_id) {
          item.domain = '';
        }
        // 当前的object_type是否支持自定义附加创意
        const additionalCreativeObjectiveEnable = customizedAdditionalCreativeObjectiveTypes.includes(objectiveType);
        const isCustomizedAdditionalCreative = additionalCreativeObjectiveEnable
          && item.format_structure === CARD_ADDITIONAL_CREATIVE_TYPE.CUSTOMIZED.value;

        const { isUseAutoGenerateCreativeName } = item;
        if (isUseAutoGenerateCreativeName) {
          item.creative_name = getAutoGenerateCreativeName(adType, item);
        }
        delete item.isUseAutoGenerateCreativeName; // 是否使用自动生成创意名称 此字段对后端无用
        delete item.autoCreativeName; // 此字段对后端无用
        delete item.native_source;
        delete item.activeCarouselImageIndex;
        delete item.enableUrl;
        delete item.enableCta;
        delete item.carouselImageInfoComponentsNameList;
        delete item.carouselImageModeChangerLoadingStatus;
        delete item.isSignProtocol; // 签署协议走单独接口不需要提交状态
        delete item.attachmentCreativeTitle; // 前端用字段不需要后端支持
        delete item.attachmentCreativeType;
        delete item.destinationEnable;
        if (![CREATIVE_TYPE.SHOP_LIVE_VIDEO, CREATIVE_TYPE.SHOP_LIVE_REAL_TIME].includes(item.creative_type)) {
          delete item.creative_type; // 后端不需要这个字段，会从数据推断(SHOP ADS LIVE除外，后端无法推断)
        }
        delete item.copy_from_ad_id; // 复制场景下的ad_id，前端用作校验，后端不需要这个字段
        delete item.advanced_creative_type; // 后端不需要这个字段，会从数据推断
        delete item.song_authorization_missing; // 对后端无用
        delete item.isCheckedMusicProtocol;

        delete item.is_valid; // 对后端无用
        delete item.rf_creative_id;

        delete item.selectedSpuMap;
        delete item.shopHasUnavailablePrd;
        delete item.spuData;
        delete item.copy_creative_shop_id;
        if (item.product_selection_type === PRODUCT_SELECTION_TYPE.SINGLE) {
          delete item.spu_list;
        }
        if (item.product_selection_type === PRODUCT_SELECTION_TYPE.MULTIPLE) {
          delete item.spu_id;
        }

        /** ---- identity相关字段处理 ---- */
        delete item.identity_data; // 此字段对后端无用

        if (!isCreativeHasIdentityWhite()) {
          delete item.identity_id;
          delete item.identity_type;
        }

        // 只有bc授权identity对应的原生创意需要传 identity_bc_id
        if (!bcIdentityTypesList.includes(item.identity_type)) {
          delete item.identity_bc_id;
        }

        const isNativeAd = adSource === NATIVE_VIDEO.value;
        // 原生视频的item_source需要区分推拉
        item.item_source = isNativeAd
          ? item.nativeAdActionType
          : adSource;
        delete item.nativeAdActionType;

        if (item.item_source !== NATIVE_AD_ACTION_TYPE.PUSH_VIDEO_TO_TTBA) {
          delete item.dark_post_status;
        }
        delete item.bc_restrict_delivery;

        item.aweme_item_id = item.aweme_item_id || (item.video_info || {}).aweme_item_id;
        if (item.disclaimer_type === DISCLAIMER_TYPES.UN_SET) {
          item.disclaimer_type = undefined;
          item.disclaimer_clickable_texts = undefined;
          item.disclaimer_text = undefined;
        }
        if (item.disclaimer_type === DISCLAIMER_TYPES.TEXT_ONLY) item.disclaimer_clickable_texts = undefined;
        if (item.disclaimer_type === DISCLAIMER_TYPES.TEXT_WITH_LINK) item.disclaimer_text = undefined;

        // dpa创意的字段特殊处理
        if (adType === CATALOGUE_VIDEO.value || adType === CATALOGUE_IMAGE.value) {
          const { dpa_word_set = [] } = item;
          item.title = transformTitle4Backend(item.title, state.dpaWordList, dpa_word_set); // 特殊字符转换
          item.is_dynamic = (dpa_word_set).length ? 1 : 0; // 标题中是否包含动态词包，前端没有用到，单纯后端接口需要
        }
        item.struct_version = state.isNewStructure ? 1 : 0;
        if (adType === SINGLE_IMAGE.value || adType === CATALOGUE_IMAGE.value) {
          if (!result.image_list) {
            result.image_list = [];
          }
          result.image_list.push(item);
        } else if (adType === SINGLE_VIDEO.value || adType === CATALOGUE_VIDEO.value) {
          delete item.isQuickOptimizeToolsShow;// 是否展示一键优化工具 后端无用
          delete item.quickOptimizeToolInfo; // 一键优化信息，后端无用
          if (!result.video_list) {
            result.video_list = [];
          }
          if (isCollectionAds) {
            // 清除 Collection Ads 不需要的参数
            item.external_url = undefined;
            item.is_open_url = undefined;
            item.open_url = undefined;
            item.auto_open = undefined;
            item.call_to_action = undefined;
            item.advanced_creative_type = undefined;
            item.call_to_action_id = undefined;
            item.fallback_type = 0;
            // collection ads 没有 card id
            item.card_id = '';
          }

          if (adType === SINGLE_VIDEO.value && isCustomizedAdditionalCreative) {
            // 未使用卡片清空卡片id
            if (!getIsAdditionalCardChecked(item)) item.card_id = '';
            // 未使用落地页清空落地页id
            if (!getIsInstantPageChecked(item)) item.page_id = '';
            if (getIsAppProfileInstantPageChecked(item)) item.auto_open = 0;
            if (getIsInstantPageChecked(item) && item.page_id) {
              item.external_url = '';
              item.open_url = '';
              item.is_open_url = undefined;
            }
          }

          if (isRF && adType === SINGLE_VIDEO.value && getIsInstantPageChecked(item) && item.page_id) {
            item.external_url = '';
            item.open_url = '';
            item.is_open_url = undefined;
          }
          // 先缓存
          const { product_set_id, product_platform_id } = item;

          // 清除 additional creative前端增加使用的参数
          for (const key of Object.keys(ADDITIONAL_CREATIVE_PARAMS)) {
            item[key] = undefined;
          }

          item = { // 把需要的字段恢复过来
            ...item,
            ...creativeRevertValueMap,
          };
          // shop ads的这2个字段不应该被清空，此处做恢复。（仅处理shopAds，其他的等productSet全量下沉后再调整）
          if (getters.isShop) {
            item.product_set_id = product_set_id;
            item.product_platform_id = product_platform_id;
          }

          result.video_list.push(item);
        } else if (adType === REAL_TIME_LIVE.value) {
          delete item.isQuickOptimizeToolsShow;// 是否展示一键优化工具 后端无用
          delete item.quickOptimizeToolInfo; // 一键优化信息，后端无用
          delete item.call_to_action; // 直投直播间不需要CTA
          delete item.call_to_action_id; //
          if (!result.video_list) {
            result.video_list = [];
          }
          result.video_list.push(item);
        } else if (adType === CAROUSEL_IMAGE.value) {
          if (!result.image_list) {
            result.image_list = [];
          }
          const { image_info = [] } = item;
          const allImagePropList = image_info
            .reduce((result, { carouselImageInfoComponentsNameList = [] }) => [...result, ...carouselImageInfoComponentsNameList], []);
          const getShouldPropEmpty = propName => allImagePropList.includes(propName);
          const titles = getShouldPropEmpty('title')
            ? image_info.map(({ title }) => title)
            : [];
          const external_urls = getShouldPropEmpty('externalUrl')
            ? image_info.map(({ externalUrl }) => externalUrl)
            : [];
          const restAttrClear = {
            title: undefined,
            externalUrl: undefined,
            uuid: undefined,
            [imageMode.CAROUSEL_IMAGE_SQUARE]: undefined,
            [imageMode.CAROUSEL_IMAGE_HORIZONTAL]: undefined,
            origin: undefined,
          };
          result.image_list.push({
            ...item, external_urls, titles, ...restAttrClear,
          });
        }
        // result[item.image_mode] = result[item.image_mode] || [];

        // if (item.image_mode) {
        //   result[item.image_mode].push(item);
        // }
      });
      return result;
    };
  },
  // 非split test时，传给后端的是creativeInfo
  creativeInfo(state, getters) {
    return getters.adsUnitCreativeInfo(state.ads[0]);
  },
  originCreativeInfo(state, getters) {
    return getters.adsUnitCreativeInfo(state.ads[0], [
      'product_platform_id',
    ]);
  },
  autoNameCreativeCount(state) {
    try {
      return state.ads
        .map(adsUnit => autoNameCreativeCountAdUnit(adsUnit))
        .reduce((result, current) => result + current, 0);
    } catch (e) {
      return 0;
    }
  },
  videoRenderByPlatformCount(state) {
    try {
      return state.ads
        .map(adsUnit => videoRenderCreativeCountAdUnit(adsUnit))
        .reduce((result, current) => result + current, 0);
    } catch (e) {
      return 0;
    }
  },
  // 开启split test时，传给后端的是batchInfo而不是creativeInfo
  batchInfo(state, getters) {
    return state.ads.map((adsUnit, index) => ({
      num: index + 1,
      creative_info: getters.adsUnitCreativeInfo(adsUnit),
    }));
  },
  isSplitTestAdsSame(state, getters) {
    if (getters.batchInfo.length < 2) return false;
    const adInfoList = getters.batchInfo.map((item) => {
      const { creative_info } = item;
      const [adInfo = [{}]] = Object.values(creative_info);
      const {
        call_to_action, image_info = [], title, image_mode, video_info, page_id,
      } = adInfo[0];
      const isVideoType = !!video_info;
      // 对url排序后转字符串，方便对比
      const imageUrlList = image_info.map(({ web_uri }) => web_uri).sort().join('');
      const vid = video_info ? video_info.vid : NaN;
      return {
        call_to_action, imageUrlList, title, image_mode, vid, isVideoType, page_id,
      };
    });
    // 去重
    const adInfoListUniq = _.uniqWith(adInfoList, _.isEqual);
    // 去重后长度发生变化，说明有至少两个广告相同
    return adInfoListUniq.length !== adInfoList.length;
  },
  // 复制创意时，如果复制个数大于 1，要把 creative_info 以类似 {creative_info: {15: [{}, {}]}} 的形式放在参数中
  copyCreativeInfo(state, getters) {
    return getters.copyUnitCreativeInfo();
  },
  copyUnitCreativeInfo(state, getters) {
    return (fieldArr) => {
      const creativeInfo = getters.adsUnitCreativeInfo(state.ads[0], fieldArr);
      const { copyNumber } = state;
      const suffix = randomString(5);
      const result = Object.keys(creativeInfo).reduce((r, v) => {
        r[v] = [];
        const [item] = creativeInfo[v] || [];
        for (let i = 0; i < copyNumber; i++) {
          // bs 新增对 creative_id 的校验，传了 creative_id 会走到后端 update 的校验逻辑，故特别删去
          delete item.creative_id;
          r[v].push({
            ...item,
            // 多个创意复制名称后补随机数 + 数字区分
            creative_name: `${ item.creative_name }-${ suffix }-${ i + 1 }`,
            domain: (item.domain === PixeOnlyTracking || !!item.page_id) ? '' : item.domain,
          });
        }
        return r;
      }, {});
      return result;
    };
  },
  originCopyCreativeInfo(state, getters) {
    return getters.copyUnitCreativeInfo([
      'product_platform_id',
    ]);
  },
  // 根据索引获得select post
  postByIndex(state) {
    return (splitTestTab) => {
      if (splitTestTab === 0) return state.selectedFormObject;
      return state.selectedFormObjectOppo;
    };
  },
  // 根据索引获取对应位置的ad
  adByIndex(state) {
    return (splitTestTab, index) => {
      if (index < 0 || splitTestTab >= state.ads.length || index >= state.ads[splitTestTab].length) {
        return null;
      }
      return state.ads[splitTestTab][index];
    };
  },
  // 根据索引获取对应位置的adSource
  adSourceByIndex(state, getters) {
    return (splitTestTab, index) => {
      const ad = getters.adByIndex(splitTestTab, index) || {};
      return ad.adSource;
    };
  },
  // 根据索引获取对应位置的adType
  adTypeByIndex(state, getters) {
    return (splitTestTab, index) => {
      const ad = getters.adByIndex(splitTestTab, index) || {};
      const { adSource } = ad;
      if (!isValidAdSource(adSource)) {
        return '';
      }
      const { adType = '' } = ad[adSource] || {};
      return adType;
    };
  },
  // 根据索引获取对应位置的当前激活素材详情
  adDetailByIndex(state, getters) {
    return (splitTestTab, index) => {
      const ad = getters.adByIndex(splitTestTab, index) || {};
      const { adSource } = ad;
      if (!isValidAdSource(adSource)) {
        return {};
      }
      const { adType = '' } = ad[adSource] || {};
      if (!adType) {
        return {};
      }
      return ad[adSource][adType];
    };
  },
  // 根据索引获取对应位置的当前激活素材的identity账号信息
  adIdentityDataByIndex(state, getters) {
    return (splitTestTab, index) => {
      const adDetail = getters.adDetailByIndex(splitTestTab, index) || {};
      const { identity_data } = adDetail;
      return identity_data || {};
    };
  },
  precheckParams(state, getters, rootState, rootGetter) {
    return (tab, isProcedural = false) => {
      const params = [];
      const { protocol } = window.location;
      if (!isProcedural) {
        // 普通创意与 split test
        const ads = state.ads[tab] || [];
        ads.forEach((ad, index) => {
          const adDetail = getters.adDetailByIndex(tab, index);
          const {
            app_name, source, image_info: imageInfo, video_info: videoInfo,
          } = adDetail;
          const isVideo = Boolean(videoInfo && videoInfo.vid);
          params.push({
            display_name: [app_name || source],
            videos: isVideo ? [videoInfo.vid] : [],
            images: isVideo ? [] : _.map(imageInfo, (image) => {
              const url = `${imgSrcPrefix.URL}${image.web_uri}`;
              const hasProtocol = url.includes('http');
              return hasProtocol ? url : `${protocol}${url}`;
            }),
          });
        });
      } else {
        const pcd = rootGetter['creative/procedural-creative-form/formData'];
        if (pcd && pcd.image_list && pcd.image_list.length) {
          pcd.image_list.forEach((item) => {
            const { image_info: imageInfo, video_info: videoInfo } = item;
            const isVideo = Boolean(videoInfo && videoInfo.vid);
            // 程序化创意把视频与图片素材分别处理，用 0 和 1 区分
            // 方便拿回机审信息时能 Match 上对应标号
            if ((tab === 0 && isVideo) || (tab === 1 && !isVideo)) {
              params.push({
                display_name: _.map(pcd.title_list, titleItem => titleItem.title),
                videos: isVideo ? [videoInfo.vid] : [],
                images: isVideo ? [] : _.map(imageInfo, (image) => {
                  const url = `${imgSrcPrefix.URL}${image.web_uri}`;
                  const hasProtocol = url.includes('http');
                  return hasProtocol ? url : `${protocol}${url}`;
                }),
              });
            }
          });
        }
      }
      return params;
    };
  },
  // 最新一个ad是否为空的：关键信息是否填写
  isLastAdEmpty(state, getters) {
    return (splitTestTab) => {
      if (splitTestTab >= state.ads.length) {
        return true;
      }
      const lastAd = getters.adByIndex(splitTestTab, state.ads[splitTestTab].length - 1) || {};
      return isAdEmpty(lastAd);
    };
  },
  // 不为空的ad列表
  fullfilledAds(state) {
    return (splitTestTab) => {
      if (splitTestTab >= state.ads.length) {
        return [];
      }
      return state.ads[splitTestTab].filter(ad => !isAdEmpty(ad));
    };
  },
  // 不为空的单图ad列表
  fullfilledImageAds(state, getters) {
    return splitTestTab => getters.fullfilledAds(splitTestTab).filter((ad) => {
      const { adSource } = ad;
      if (!isValidAdSource(adSource)) {
        return false;
      }
      const sourceTarget = ad[adSource] || {};
      const { adType = '' } = sourceTarget;
      return [SINGLE_IMAGE.value, CATALOGUE_IMAGE.value].includes(adType);
    });
  },
  fullfilledCarouselImageAds(state, getters) {
    return splitTestTab => getters.fullfilledAds(splitTestTab).filter((ad) => {
      const { adSource } = ad;
      if (!isValidAdSource(adSource)) {
        return false;
      }
      const sourceTarget = ad[adSource] || {};
      const { adType = '' } = sourceTarget;
      return [CAROUSEL_IMAGE.value].includes(adType);
    });
  },
  // 不为空的单视频ad列表
  fullfilledVideoAds(state, getters) {
    return splitTestTab => getters.fullfilledAds(splitTestTab).filter((ad) => {
      const { adSource } = ad;
      if (!isValidAdSource(adSource)) {
        return false;
      }
      const sourceTarget = ad[adSource] || {};
      const { adType = '' } = sourceTarget;
      return [SINGLE_VIDEO.value, CATALOGUE_VIDEO.value].includes(adType);
    });
  },
  /**
   * 获取某种类型不为空的 ad 列表
   * @param {Number} splitTestTab
   * @param {Array} targetAdTypeList adType 列表，不存在则代表全部
   * @param {Boolean} isQueryAdFormatData 是否是获取 ad 具体的创意数据
   */
  fullfilledAdsByType(state, getters) {
    return ({
      splitTestTab, targetAdTypeList, isQueryAdFormatData = false, checkAdEmptyStatus = false,
    }) => {
      const currentSplitTestAdList = checkAdEmptyStatus
        ? getters.fullfilledAds(splitTestTab)
        : state.ads[splitTestTab] || [];
      const adsFormat = [];
      const ads = currentSplitTestAdList.filter((ad) => {
        const { adSource } = ad;
        if (!isValidAdSource(adSource)) return false;
        const sourceTarget = ad[adSource] || {};
        const { adType = '' } = sourceTarget;
        const flag = !targetAdTypeList || targetAdTypeList.includes(adType);
        if (flag) adsFormat.push(sourceTarget[adType]);
        return flag;
      });
      return isQueryAdFormatData ? adsFormat : ads;
    };
  },
  // 是否创意填了有效视频素材
  isAdHasVideo(state, getters) {
    return (splitTestTab, index) => {
      if (splitTestTab >= state.ads.length) {
        return false;
      }
      const ad = getters.adByIndex(splitTestTab, index);
      const adType = getters.adTypeByIndex(splitTestTab, index);
      return (
        // 单视频创意需要不为空，DPA视频创意认为始终有视频素材
        (!isAdEmpty(ad) && adType === SINGLE_VIDEO.value) ||
        adType === CATALOGUE_VIDEO.value
      );
    };
  },
  // 是否创意填了有效图片素材
  isAdHasImage(state, getters) {
    return (splitTestTab, index) => {
      if (splitTestTab >= state.ads.length) {
        return false;
      }
      const ad = getters.adByIndex(splitTestTab, index);
      const adType = getters.adTypeByIndex(splitTestTab, index);

      // 单图/单视频/多图轮播创意不能为空
      const hasImage4NormalAd = !isAdEmpty(ad) &&
        (adType === SINGLE_IMAGE.value
          || adType === SINGLE_VIDEO.value
          || adType === CAROUSEL_IMAGE.value);
      const hasImage4DpaAd = adType === CATALOGUE_IMAGE.value || adType === CATALOGUE_VIDEO.value; // DPA创意认为始终有图片
      const isRealTimeLive = adType === REAL_TIME_LIVE.value; // 直投直播间
      return hasImage4NormalAd || hasImage4DpaAd || isRealTimeLive;
    };
  },
  // create new形式下，是否存在选中类型是单视频且上传了视频素材的
  hasFullfilledSingleVideo(state) {
    return (splitTestTab) => {
      if (splitTestTab >= state.ads.length) {
        return false;
      }

      return state.ads[splitTestTab].some((ad) => {
        const { adSource } = ad;
        // 只判断create new
        if (adSource !== CREATE_NEW.value) {
          return false;
        }
        const { adType } = ad[adSource];

        if (adType === AD_TYPE.SINGLE_VIDEO.value) {
          const { video_info } = ad[adSource][adType] || {};
          return !!video_info;
        }
        return false;
      });
    };
  },
  /**
   * Ad 是否是 Storefront 创意（PLP/PDP)
   */
  isAdSelectStorefrontCreative(state, getters) {
    return (splitTestTab, index) => getters.isPLPCreative(splitTestTab, index) || getters.isShopAdsCreative(splitTestTab, index);
  },
  /**
   * 是否PLP创意
   */
  isPLPCreative(state, getters) {
    return (splitTestTab, index) => {
      const adDetail = getters.adDetailByIndex(splitTestTab, index);
      return CREATIVE_TYPE.LYNX_PLP === adDetail.creative_type;
    };
  },
  /**
   * 是否ShopAds创意
   */
  isShopAdsCreative(state, getters) {
    return (splitTestTab, index) => {
      const adDetail = getters.adDetailByIndex(splitTestTab, index);
      return [CREATIVE_TYPE.SHOP_PDP, CREATIVE_TYPE.SHOP_PLP].includes(adDetail.creative_type);
    };
  },
  /**
   * 是否有创意签署了协议
   * lead ads 和 plp/pdp 需要签署协议
   */
  hasCreativeSigningProtocol(state, getters) {
    return () => state.ads.some((adsUnit, index) => {
      const adList = getters.fullfilledAdsByType({
        splitTestTab: index,
        isQueryAdFormatData: true,
        checkAdEmptyStatus: true,
      });
      return adList.some(ad => ad.isSignProtocol);
    });
  },
  /** --------------------------------   版位相关 start    ------------------------------------------------ */
  allApps(state) {
    return state.appTypes.includes(INVENTORY_FLOW.ALL);
  },
  // TODO: 这些代码与src/mixins/ad-group/inventoryFlowMixin重复了，合并到一起
  hasTopbuzz(state, getters) {
    return (
      getters.allApps || state.appTypes.includes(INVENTORY_FLOW.TOPBUZZ)
    );
  },
  // TopbuzzOnly(state) {
  //   const onlyOneAppSelected = state.appTypes.length === 1;
  //   const TopbuzzSelected = state.appTypes.includes(INVENTORY_FLOW.TOPBUZZ);
  //   return onlyOneAppSelected && TopbuzzSelected;
  // },
  isOnlyTopBuzz(state) {
    return (
      state.appTypes.length === 1 &&
      state.appTypes[0] === INVENTORY_FLOW.TOPBUZZ
    );
  },
  hasTiktok(state, getters) {
    return (
      getters.allApps || state.appTypes.includes(INVENTORY_FLOW.TIKTOK)
    );
  },
  hasVigo(state, getters) {
    return getters.inventoryFlowKeys.includes(INVENTORY_FLOW.VIGO);
  },
  hasTiktokAdNetwork(state, getters) {
    return (
      (getters.allApps ||
        state.appTypes.includes(INVENTORY_FLOW.TIKTOKADNETWORK))
    );
  },
  hasHelo(state, getters) {
    return (getters.allApps || state.appTypes.includes(INVENTORY_FLOW.HELO));
  },
  enableImage(state, getters) {
    return getters.hasTopbuzz ||
      getters.hasVigo ||
      getters.hasHelo ||
      (isSupportPangleImage(getters.isDpa) && getters.hasTiktokAdNetwork);
  },
  // 是否支持多图轮播
  enableCarouselImage(state, getters, rootState, rootGetter) {
    // 仅app install 并且 仅选择了TBBV的支持轮播
    const objectiveType = _.get(rootState, 'campaign.adgroup.objective_type');
    // const adGroupCountries = _.get(rootState, 'campaign.adgroup.country');
    // Objective 一期支持的目标
    const isObjectEnable_v1 = CAROUSEL_ENABLE_OBJECTIVE_LIST_V1.includes(objectiveType);
    // Objective 二期支持的目标
    const isObjectEnable_v2 = CAROUSEL_ENABLE_OBJECTIVE_LIST_V2.includes(objectiveType);
    // 是否展示v1
    const isEnable_v1 = isObjectEnable_v1 && isCarouselImageCreativeAllowed_v1();
    // 是否展示v2
    const isEnable_v2 = isObjectEnable_v2 && isCarouselImageCreativeAllowed_v2();
    const isEnable = isEnable_v1 || isEnable_v2;
    // 多图轮播可投国家与adGroup选择的国家取交集， 有交集说明选择了可投国家
    // 待创意层级数据规范后回到这里
    // const hasAllowedCountry = _.intersection(CAROUSEL_IMAGE_CREATIVE_ALLOWED_COUNTRIES, adGroupCountries).length > 0;

    // 支持轮播条件（同时满足）：
    // 1. 版位包含TBBV
    // 2. Objective 为 CAROUSEL_ENABLE_OBJECTIVE_LIST 中的版位（AppInstall、 Conversion、Traffic）
    // 3. 包含允许的投放国家
    // 4. 白名单
    return getters.hasTopbuzz
      // && hasAllowedCountry
      && isEnable;
  },
  inventoryFlows(state, getters) {
    const keys = Object.keys(INVENTORY_FLOW_MAP);

    const result = [];
    if (getters.allApps) {
      keys.forEach((item) => {
        const { key } = INVENTORY_FLOW_MAP[item];
        if (
          key !== INVENTORY_FLOW.ALL &&
          (isVigoWhite() || key !== INVENTORY_FLOW.VIGO) // vigo有白名单限制
        ) {
          result.push(INVENTORY_FLOW_MAP[item]);
        }
      });
    } else {
      keys.forEach((item) => {
        if (state.appTypes.includes(INVENTORY_FLOW_MAP[item].key)) {
          result.push(INVENTORY_FLOW_MAP[item]);
        }
      });
    }
    return result.filter(item => item.key !== INVENTORY_FLOW.VIGO && item.key !== INVENTORY_FLOW.HELO);
  },
  inventoryFlowKeys(state, getters) {
    return getters.inventoryFlows.map(option => option.key);
  },
  // identity是否可用
  isIdentityAvailable(state) {
    return [identityAvailableStatus.Available, identityAvailableStatus.NOT_IDENTITY].includes(state.identityAuthorizationState);
  },
  isShopAvailable(state) { // shop有权限
    return [shopStateMap.available].includes(state.shopAuthorizationState);
  },
  /** --------------------------------   版位相关 end    ------------------------------------------------ */
  isCatalogVideo(state, getters) {
    return (splitTestTab, index) => {
      const adType = getters.adTypeByIndex(splitTestTab, index);
      return adType === CATALOGUE_VIDEO.value;
    };
  },
  isCatalogImage(state, getters) {
    return (splitTestTab, index) => {
      const adType = getters.adTypeByIndex(splitTestTab, index);
      return adType === CATALOGUE_IMAGE.value;
    };
  },
  // 是否存在某个shop创意有不可用商品
  isShopAdsHasUnavailablePrd(state, getters) {
    if (!getters.isShop) {
      return false;
    }
    const ads = state.ads?.[0]?.map((ad, index) => getters.adDetailByIndex(0, index)) || [];
    const isShopHasUnavailablePrd = ads.some(ad => !!(ad.isShopHasUnavailablePrd));
    return isShopHasUnavailablePrd;
  },
};
